import { State } from '../../types';

export const virginia: State = {
  name: 'Virginia',
  abbreviation: 'VA',
  terms: [
    {
      word: 'Aquia',
      phonetic: 'ah-KWY-ah',
      // audioUrl: '/audio/aquia.mp3',
      description: 'A district in Stafford County, pronounced "ah-KWY-ah," not "ah-KEE-ah."'
    },
    {
      word: 'Botetourt',
      phonetic: 'BOT-uh-tot',
      // audioUrl: '/audio/botetourt.mp3',
      description: 'A county in the Roanoke region, pronounced "BOT-uh-tot," not "BOAT-tort."'
    },
    {
      word: 'Buena Vista',
      phonetic: 'BYOO-nuh VIS-tuh',
      // audioUrl: '/audio/buena_vista.mp3',
      description: 'An independent city, pronounced "BYOO-nuh VIS-tuh," differing from the Spanish pronunciation.'
    },
    {
      word: 'Chilhowie',
      phonetic: 'chill-HOW-ee',
      // audioUrl: '/audio/chilhowie.mp3',
      description: 'A town in Smyth County, pronounced "chill-HOW-ee," not "chill-HOE-ee."'
    },
    {
      word: 'Fauquier',
      phonetic: 'faw-KEER',
      // audioUrl: '/audio/fauquier.mp3',
      description: 'A county in Northern Virginia, pronounced "faw-KEER," not "faw-KWAI-er."'
    },
    {
      word: 'Fries',
      phonetic: 'freeze',
      // audioUrl: '/audio/fries.mp3',
      description: 'A town in Grayson County, pronounced "freeze," not like the potato product.'
    },
    {
      word: 'Gloucester',
      phonetic: 'GLOSS-ter',
      // audioUrl: '/audio/gloucester.mp3',
      description: 'A county in the Tidewater region, pronounced "GLOSS-ter," not "GLOW-chest-er."'
    },
    {
      word: 'Huguenot',
      phonetic: 'HYOO-guh-not',
      // audioUrl: '/audio/huguenot.mp3',
      description: 'A community in Powhatan County, pronounced "HYOO-guh-not," not "HYOO-gwen-oh."'
    },
    {
      word: 'Jahnke',
      phonetic: 'jank',
      // audioUrl: '/audio/jahnke.mp3',
      description: 'A neighborhood in Richmond, pronounced "jank," ignoring the "h" and "e."'
    },
    {
      word: 'Loudoun',
      phonetic: 'LOUD-un',
      // audioUrl: '/audio/loudoun.mp3',
      description: 'A county in Northern Virginia, pronounced "LOUD-un," not "LEW-dun."'
    },
    {
      word: 'Mathews',
      phonetic: 'MATH-ews',
      // audioUrl: '/audio/mathews.mp3',
      description: 'A county in the Middle Peninsula, pronounced "MATH-ews," not "MAY-thus."'
    },
    {
      word: 'Matoaca',
      phonetic: 'muh-TOH-kuh',
      // audioUrl: '/audio/matoaca.mp3',
      description: 'A community in Chesterfield County, pronounced "muh-TOH-kuh," not "muh-TOH-ah-kuh."'
    },
    {
      word: 'Mattaponi',
      phonetic: 'mat-uh-poe-NYE',
      // audioUrl: '/audio/mattaponi.mp3',
      description: 'An unincorporated community in King and Queen County, pronounced "mat-uh-poe-NYE," not "mat-uh-poe-nee."'
    },
    {
      word: 'McGaheysville',
      phonetic: 'muh-GAK-eez-vil',
      // audioUrl: '/audio/mcgaheysville.mp3',
      description: 'A community in Rockingham County, pronounced "muh-GAK-eez-vil," not "muh-GAY-heez-vil."'
    },
    {
      word: 'Norfolk',
      phonetic: 'NAW-fuhk',
      // audioUrl: '/audio/norfolk.mp3',
      description: 'An independent city, pronounced "NAW-fuhk," not "NOR-folk."'
    },
    {
      word: 'Poquoson',
      phonetic: 'puh-KOH-sun',
      // audioUrl: '/audio/poquoson.mp3',
      description: 'An independent city, pronounced "puh-KOH-sun," not "po-KWO-son."'
    },
    {
      word: 'Portsmouth',
      phonetic: 'PORT-smith',
      // audioUrl: '/audio/portsmouth.mp3',
      description: 'An independent city, pronounced "PORT-smith," not "PORTS-mouth."'
    },
    {
      word: 'Powhatan',
      phonetic: 'POW-uh-tan',
      // audioUrl: '/audio/powhatan.mp3',
      description: 'A county in Central Virginia, pronounced "POW-uh-tan," not "POW-hat-an."'
    },
    {
      word: 'Schuyler',
      phonetic: 'SKY-lur',
      // audioUrl: '/audio/schuyler.mp3',
      description: 'A community in Nelson County, pronounced "SKY-lur," not "SHOO-ler."'
    },
    {
      word: 'Staunton',
      phonetic: 'STAN-ton',
      // audioUrl: '/audio/staunton.mp3',
      description: 'An independent city, pronounced "STAN-ton," not "STAWN-ton."'
    },
    {
      word: 'Suffolk',
      phonetic: 'SUF-fuhk',
      // audioUrl: '/audio/suffolk.mp3',
      description: 'An independent city, pronounced "SUF-fuhk," not "SUF-folk."'
    },
    {
      word: 'Tappahannock',
      phonetic: 'tap-uh-HAN-ock',
      // audioUrl: '/audio/tappahannock.mp3',
      description: 'A town in Essex County, pronounced "tap-uh-HAN-ock," not "tap-uh-HAN-nock."'
    },
    {
      word: 'Weyers Cave',
      phonetic: 'WEERZ cave',
      // audioUrl: '/audio/weyers_cave.mp3',
      description: 'A community in Augusta County, pronounced "WEERZ cave," not "WAY-ers cave."'
    },
    {
      word: 'Zuni',
      phonetic: 'ZOO-nye',
      // audioUrl: '/audio/zuni.mp3',
      description: 'A small community in Isle of Wight County, pronounced "ZOO-nye," not "ZOO-nee."'
    }
  ]
};